import { create } from 'zustand';

interface WindowState {
  title: string | null;
  onClose: (() => void) | null;
  leftBar: React.ReactNode | null;  // основные кнопки слева (Провести, Сохранить...)
  topBar: React.ReactNode | null;   // второстепенные кнопки справа (экшен бар, фильтры)
  openWindow: (title: string, onClose: () => void, topBar?: React.ReactNode, leftBar?: React.ReactNode) => void;
  closeWindow: () => void;
}

export const useWindowStore = create<WindowState>((set) => ({
  title: null,
  onClose: null,
  leftBar: null,
  topBar: null,
  openWindow: (title, onClose, topBar = null, leftBar = null) => set({ title, onClose, topBar, leftBar }),
  closeWindow: () => { set((s) => { s.onClose?.(); return { title: null, onClose: null, topBar: null, leftBar: null }; }); },
}));
